import React from 'react'
import { MwInputText,MwTextArea,MwButton, TitleGroup, MwSwitch } from '../../../components/ui'
import MwInputFile from '../../../components/ui/MwInputFile'
import { useTranslation } from 'react-i18next'

const ServiceForm = ({
    errors,
    formState,
    setFormState,
    saveHanlder,
    title,
    uploadLogoHandler,
    uploadLoading
}) => {
    const [t] = useTranslation('global')
    const resolvedTitle = title || t('services.addTitle')
    return (
        <div className='flex flex-col gap-3 justify-between rounded-xl bg-slate-100 p-3 '>
            <TitleGroup>{resolvedTitle}</TitleGroup>
            <MwInputText
                label={t('services.name')}
                value={formState.serviceName}
                onChange={(e)=>setFormState((state) => ({...state,serviceName:e.target.value}))}
                invalid={!!errors?.serviceName}
                invalidMsg={errors?.serviceName}
                />
            <MwInputText
                label={t('services.nameEn')}
                value={formState.serviceNameEn}
                onChange={(e)=>setFormState((state) => ({...state,serviceNameEn:e.target.value}))}
                invalid={!!errors?.serviceNameEn}
                invalidMsg={errors?.serviceNameEn}
                />
            <MwTextArea
                label={t('services.description')}
                value={formState.serviceDesc}
                onChange={(e)=>setFormState((state) => ({...state,serviceDesc:e.target.value}))}
                invalid={!!errors?.serviceDesc}
                invalidMsg={errors?.serviceDesc}
                />
            <MwTextArea
                label={t('services.descriptionEn')}
                value={formState.serviceDescEn}
                onChange={(e)=>setFormState((state) => ({...state,serviceDescEn:e.target.value}))}
                invalid={!!errors?.serviceDescEn}
                invalidMsg={errors?.serviceDescEn}
                />
            <MwInputText
                label={t('services.logo')}
                value={formState.serviceLogo}
                onChange={(e)=>setFormState((state) => ({...state,serviceLogo:e.target.value}))}
                invalid={!!errors?.serviceLogo}
                invalidMsg={errors?.serviceLogo}
                />
            <MwInputFile
                id='service_logo_file'
                label={t('services.uploadLogo')}
                onChangeHandler={uploadLogoHandler}
                loading={uploadLoading}
                acceptTypes='image/*'
            />
            <div className='rounded-xl border border-slate-200 bg-white p-3 flex justify-center items-center min-h-28'>
                {formState.serviceLogo ? (
                    <img
                        src={formState.serviceLogo}
                        alt={t('services.logo')}
                        className='max-h-24 w-auto object-contain'
                    />
                ) : (
                    <span className='text-xs text-slate-400'>{t('services.logo')}</span>
                )}
            </div>
            <div className='flex flex-col gap-1'>
                <span className='text-xs text-slate-600'>{t('services.defaultLanguage')}</span>
                <select
                    className='h-9 rounded-lg border border-slate-200 bg-white px-3 text-xs text-slate-700 outline-none'
                    value={formState.defaultLanguage || ''}
                    onChange={(e) => setFormState((state) => ({ ...state, defaultLanguage: e.target.value }))}
                >
                    <option value=''>{t('common.none')}</option>
                    <option value='ar'>{t('services.defaultLanguageAr')}</option>
                    <option value='en'>{t('services.defaultLanguageEn')}</option>
                </select>
            </div>
            <div className='grid gap-3 md:grid-cols-2'>
                <div className='flex items-center justify-between rounded-lg bg-white px-3 py-2'>
                    <span className='text-xs text-slate-600'>{t('services.showEmployeeRating')}</span>
                    <MwSwitch
                        custKey='showEmployeeRating'
                        isActive={!!formState.showEmployeeRating}
                        setIsActive={(value) => setFormState((state) => ({...state, showEmployeeRating: value}))}
                    />
                </div>
                <div className='flex items-center justify-between rounded-lg bg-white px-3 py-2'>
                    <span className='text-xs text-slate-600'>{t('services.showPricesQuestion')}</span>
                    <MwSwitch
                        custKey='showPricesQuestion'
                        isActive={!!formState.showPricesQuestion}
                        setIsActive={(value) => setFormState((state) => ({...state, showPricesQuestion: value}))}
                    />
                </div>
                <div className='flex items-center justify-between rounded-lg bg-white px-3 py-2'>
                    <span className='text-xs text-slate-600'>{t('services.showHowToImprove')}</span>
                    <MwSwitch
                        custKey='showHowToImprove'
                        isActive={!!formState.showHowToImprove}
                        setIsActive={(value) => setFormState((state) => ({...state, showHowToImprove: value}))}
                    />
                </div>
                <div className='flex items-center justify-between rounded-lg bg-white px-3 py-2'>
                    <span className='text-xs text-slate-600'>{t('services.showMobileNumber')}</span>
                    <MwSwitch
                        custKey='showMobileNumber'
                        isActive={!!formState.showMobileNumber}
                        setIsActive={(value) => setFormState((state) => ({...state, showMobileNumber: value}))}
                    />
                </div>
                <div className='flex items-center justify-between rounded-lg bg-white px-3 py-2'>
                    <span className='text-xs text-slate-600'>{t('services.showServiceName')}</span>
                    <MwSwitch
                        custKey='showServiceName'
                        isActive={!!formState.showServiceName}
                        setIsActive={(value) => setFormState((state) => ({...state, showServiceName: value}))}
                    />
                </div>
                <div className='flex items-center justify-between rounded-lg bg-white px-3 py-2'>
                    <span className='text-xs text-slate-600'>{t('services.showServiceDesc')}</span>
                    <MwSwitch
                        custKey='showServiceDesc'
                        isActive={!!formState.showServiceDesc}
                        setIsActive={(value) => setFormState((state) => ({...state, showServiceDesc: value}))}
                    />
                </div>
            </div>
            <div className='flex justify-end'>
                <MwButton onClick={saveHanlder} type='saveBtn' ><span className='pt-1'>{t('common.save')}</span></MwButton>
            </div>
            
    </div>
    )
}

export default ServiceForm
